import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { ContractsReport } from '@weft/types';
import { caseInsensitiveIncludes, isNullOrUndefined } from '@weft/utils';
import { VyTable } from 'apps/app/src/components/new-design/table/vy-table/VyTable';
import { useMemo } from 'react';
import { CONTRACTS_REPORT_COLUMNS } from './ContractsReportTableColumns';

type ContractsReportTableProps = {
  rows: ContractsReport;
  filter?: string;
  apiRef?: React.MutableRefObject<GridApiCommunity>;
  isLoading?: boolean;
};
    
export const ContractsReportTable: React.FC<ContractsReportTableProps> = ({ isLoading, filter, apiRef, rows }) => {
  const filteredRows = useMemo(() => rows.filter(({ customerName }) => isNullOrUndefined(filter) || caseInsensitiveIncludes(customerName, filter)), [rows, filter]);
    
  return (
    <VyTable
      columns={CONTRACTS_REPORT_COLUMNS}
      items={filteredRows}
      itemsCount={filteredRows.length}
      loadingItems={isLoading}
      apiRef={apiRef}
      getRowId={() => crypto.randomUUID()}
      disableColumnMenu
      showPagination={false} 
      hideFooter={false}
      sx={{
        paddingBottom: '80px',
      }}
    />
  );
};